module.exports = __webpack_public_path__ + "img/img8.f8283d87.jpg";